/* eslint-disable class-methods-use-this */
import axios from "axios";

import {
  API_ORDER_MANAGEMENT_URL,
  API_ORDER_PROCESSING_URL,
  COMMON_HEADER_CONFIG
} from "../config";

class PicklistService {
  getAccessToken = () => localStorage.getItem("accessToken");

  searchPicklist = (data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_ORDER_PROCESSING_URL}/picklist`,
        params: {
          size: 100,
          page: 1,
          ...data
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error.response?.data?.error);
        });
    });

  getList = (states, stationFrom) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_ORDER_PROCESSING_URL}/picklist`,
        params: {
          size: 100,
          page: 1,
          state: states,
          station_from: stationFrom
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  checkConsolidation = (id, state = "checked_out", type, stationFrom) =>
    new Promise((resolve, reject) => {
      let params;
      if (type === "bag") {
        params = {
          search: id,
          state,
          station_from: stationFrom
        };
      } else if (type === "package") {
        params = {
          picklist_number: id,
          state
        };
      }
      const config = {
        method: "get",
        url: `${API_ORDER_PROCESSING_URL}/check-consolidation`,
        params,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  checkBagState = (id, state = "checked_out", type, stationFrom) =>
    new Promise((resolve, reject) => {
      let params;
      if (type === "bag") {
        params = {
          search: id,
          state,
          station_from: stationFrom
        };
      } else if (type === "package") {
        params = {
          picklist_number: id,
          state
        };
      }
      const config = {
        method: "get",
        url: `${API_ORDER_PROCESSING_URL}/bag/check-bag-state`,
        params,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  createMultiBag = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "POST",
        url: `${API_ORDER_PROCESSING_URL}/bag/create-multi-bag`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getOne = (picklistNumber) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_ORDER_PROCESSING_URL}/picklist/${picklistNumber}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  update = (picklistNumber, data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "PUT",
        url: `${API_ORDER_PROCESSING_URL}/picklist/${picklistNumber}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          resolve(error.response.data);
        });
    });

  deletePicklist = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "DELETE",
        url: `${API_ORDER_PROCESSING_URL}/uploads/delete`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data: {ids: [id]}
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(id);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updatePicklistIsPrinted = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "POST",
        url: `${API_ORDER_PROCESSING_URL}/uploads/update`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateByTradeOrderNumber = (tradeOrderNumber, data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "PUT",
        url: `${API_ORDER_PROCESSING_URL}/update-from-tradeorder/${tradeOrderNumber}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.message);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  createBagNumber = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "GET",
        url: `${API_ORDER_PROCESSING_URL}/bag`,
        params: {
          ...data
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.total_items);
          } else {
            reject(response.data.message);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getListBag = (data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_ORDER_PROCESSING_URL}/bag`,
        params: {
          limit: 100,
          page: 1,
          ...data
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getListBagByStation = (data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_ORDER_PROCESSING_URL}/bag`,
        params: {
          size: 100,
          page: 1,
          ...data
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  // picklist management
  getPicklistAP = (params = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_ORDER_PROCESSING_URL}/picklist`,
        params: {
          size: 10,
          page: 1,
          option: "admin-portal",
          ...params
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error.response?.data?.error);
        });
    });

  getHistoryPicklist = (picklist_number) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_ORDER_PROCESSING_URL}/history-picklist?picklist_number=${picklist_number}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  assignPicklist = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "post",
        url: `${API_ORDER_PROCESSING_URL}/assign-picklist`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  cancelAssignPicklist = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "post",
        url: `${API_ORDER_PROCESSING_URL}/assign-picklist/cancel`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateFromTradeOrder = (id, data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "put",
        url: `${API_ORDER_PROCESSING_URL}/update-from-tradeorder/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateBagFlow = (id, data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "post",
        url: `${API_ORDER_PROCESSING_URL}/bag/update-bag-flow/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateStationPicklist = (picklistNumber, data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "put",
        url: `${API_ORDER_PROCESSING_URL}/picklist/${picklistNumber}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });

  updatePickedItemBundle = (data, id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "patch",
        url: `${API_ORDER_MANAGEMENT_URL}/order-bundle-item/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });

  getOrderItemsBundle = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "GET",
        url: `${API_ORDER_MANAGEMENT_URL}/order-item/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
}

const picklistService = new PicklistService();

export default picklistService;
